import { CssBaseline, Typography } from "@mui/material";
import { Container} from "@mui/material";
export default function SupportPage(){
    return(
        <Container component='main'>
        <CssBaseline />
        <Typography>
           Support Page
        </Typography>
    </Container>
    );
}